import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vnd-per-m',
  templateUrl: './vnd-per-m.component.html',
  styleUrls: ['./vnd-per-m.component.scss']
})
export class VndPerMComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
